import { useEffect, useState } from "react";
import BlogCard from "../components/BlogCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BlogsPage() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/blogs`)
      .then((response) => response.ok ? response.json() : [])
      .then(setPosts)
      .finally(() => setLoading(false));
  }, []);

  return <main className="blog-page page-width" data-testid="blog-page"><header className="content-page-heading"><span className="eyebrow">ApprenticeWala Journal</span><h1>Guidance that helps your skills go further.</h1><p>Government updates, apprenticeship information, and practical career guidance for every beginning.</p></header>{loading ? <p data-testid="blog-loading">Loading articles…</p> : <section className="blog-list" data-testid="blog-list">{posts.map((post) => <BlogCard post={post} key={post.id} />)}</section>}</main>;
}